import { StateInterface } from "./state";

export default {
  loginBackground(state: StateInterface): boolean | string {
    return state.loginBackground;
  },
  branded(state: StateInterface): boolean {
    return state.branded;
  },
  applicationName(state: StateInterface): string {
    return state.applicationName;
  },
};
